import script from "./CompletedContent.vue?vue&type=script&setup=true&lang=js"
export * from "./CompletedContent.vue?vue&type=script&setup=true&lang=js"

import "./CompletedContent.vue?vue&type=style&index=0&id=7c7c1fed&scoped=true&lang=css"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c7c1fed"]])

export default __exports__